import axios from 'axios';
import { BUILDING_METADATA_SERVICE_BASE } from '../constants';
import { getHeaders } from './AuthService';

export const searchGraph = async (string, showDetails, context, entityId, options = {}) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + "/search", {
        ...options,
        params: {
            q: string,
            details: showDetails,
            context: (context || ""),
            entity_id: (entityId || ""),
        },
        headers: await getHeaders(),
    });
    return results.data;
  };

export const searchDetails = async (string) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/search/details?q=` + string, {
        headers: await getHeaders(),
    });
    return results.data;
  };

export const getAllSites = async (details) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/?details=${details}`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

export const getProducts = async () => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/products`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

export const getAllEquipment = async () => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/equipment`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

export const getAllBuildings = async () => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

export const getAllSchedules = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/schedules`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

export const getAllContacts= async () => {
    let results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/contacts/`, {
        headers: await getHeaders(),
    });
    return results.data && results.data.contacts;
  };

export const getAllDocuments = async (entityType, id) => {
  let results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/${entityType}/${id}/documents/`, {
      headers: await getHeaders(),
  });
  return results.data;
};

export const getAllDocumentFileTypes = async (entityType) => {
  let results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/${entityType}/file_types/`, {
      headers: await getHeaders(),
  });
  return results.data;
};

export const generatePresignedUpload = async (entityType, id, path) => {
  let results = await axios.post(`${BUILDING_METADATA_SERVICE_BASE()}/${entityType}/${id}/documents/${path}`, undefined, {
      headers: await getHeaders(),
  });
  return results.data;
};

export const generateDownloadUrl = async (entityType, id, path) => {
  return generateDownloadUrlFromPath(`${entityType}/${id}/documents/${path}`)
};

export const generateDownloadUrlFromPath = async (fullPath) => {
  let results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/${fullPath}`, {
    headers: await getHeaders(),
  });
  return results.data;
};

export const getContactRoles = async () => {
    const results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/contacts/role-options/`, {
        headers: await getHeaders(),
    });
    return results.data;
};

export const addSite  = async (site) => {
    let results = await axios.post(`${BUILDING_METADATA_SERVICE_BASE()}/locations/sites`, site, {
        headers: await getHeaders(),
    });
    return results.data;
  };


  export const addContact  = async (contact) => {
    let results = await axios.post(`${BUILDING_METADATA_SERVICE_BASE()}/contacts/`, contact, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getEntitySchedules = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/schedules/entities`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addSchedule = async (schedule) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/schedules/`, schedule, {
        headers: await getHeaders(),
    });
    return results && results.data;
  };

  export const linkScheduleToEntity = async (entityType, entityId, schedule) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/${entityType}/${entityId}/schedules/${schedule.id}`, null, {
        headers: await getHeaders(),
    });
    console.log(results)
    return results.data;
  };

  export const addScheduleBlock = async (block) => {
    let scheduleId = block.schedule_id
    let typePath = block.type === "Event" ? "events" : "repeating"
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/schedules/` + scheduleId + `/` + typePath, block, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const editScheduleBlock = async (block) => {
    let scheduleId = block.schedule_id
    let typePath = block.type === "Event" ? "events" : "repeating"
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/schedules/` + scheduleId + `/` + typePath + '/' + block.id, block, {
        headers: await getHeaders(),
    });
    return results.data;
  };
  export const deleteScheduleBlock = async (block) => {
    let scheduleId = block.schedule_id
    let results = await axios.delete(BUILDING_METADATA_SERVICE_BASE() + `/schedules/` + scheduleId + `/blocks/` + block.id, block, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSiteBuildings = async (siteId) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + siteId + "/buildings/" , {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const siteById = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + "/", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSiteContacts  = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/contacts/', {
        headers: await getHeaders(),
    });
    return results.data && results.data.contacts;
  };

  export const getEquipmentContacts  = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + id + '/contacts/', {
        headers: await getHeaders(),
    });
    return results.data && results.data.contacts;
  };

  export const associateSiteContact  = async (siteId, contactEmail) => {
    let body = {
        email: contactEmail
    }
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + siteId + '/contacts', body, {
        headers: await getHeaders(),
    });
    return results.data && results.data.contacts;
  };

  export const associateEquipmentContact  = async (id, contactEmail) => {
    let body = {
        email: contactEmail
    }
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + id + '/contacts', body, {
        headers: await getHeaders(),
    });
    return results.data && results.data.contacts;
  };
  export const getSiteSpaces = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/spaces', {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSiteZones = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/zones', {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSiteEquipment = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/equipment', {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSiteInterfaces = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/interfaces', {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSiteNotes = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/notes/', {
        headers: await getHeaders(),
    });
    return results.data && results.data.notes;
  };

  export const getSiteVariables = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/variables', {
        headers: await getHeaders(),
    });
    return results.data && results.data.variables;
  };

  export const getCommunicationInterfaces = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + '/interfaces', {
        headers: await getHeaders(),
    });
    return results.data;
  };


  export const equipmentById = async (id) => {
    let results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/equipment/${id}/`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getPointsForEquipment = async (id, active = undefined) => {
    const qs = active !== undefined ? `?active=${active}` : '';
    let results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/equipment/${id}/points${qs}`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getEquipmentVariables = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + id + '/variables', {
        headers: await getHeaders(),
    });
    return results.data && results.data.variables;
  };

  export const getEquipmentNotes = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + id + '/notes', {
        headers: await getHeaders(),
    });
    return results.data && results.data.notes;
  };

  export const getRelatedEquipment = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + id + '/related', {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const spaceById = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + id, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSpaceEquipment = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + id + "/equipment", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const zoneById = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/` + id, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getZoneEquipment = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/` + id + "/equipment", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getZoneSpaces = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/` + id + "/spaces", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getZoneNotes = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/` + id + '/notes', {
        headers: await getHeaders(),
    });
    return results.data && results.data.notes;
  };

  export const getZoneSchedules = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/` + id + '/schedules', {
        headers: await getHeaders(),
    });
    return results.data && results.data;
  };

  export const buildingById = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getBuildingVariables = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id + '/variables', {
        headers: await getHeaders(),
    });
    return results.data && results.data.variables;
  };



  export const getBuildingEquipment = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id + "/equipment", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getBuildingSpaces = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id + "/spaces", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getBuildingZones = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id + "/zones", {
        headers: await getHeaders(),
    });
    return results.data;
  };


  export const getSpaceZones = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + id + "/zones", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSpaceFeatures = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + id + "/features", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const featureById = async (id) => {
    let results = await axios.get(`${BUILDING_METADATA_SERVICE_BASE()}/features/${id}/`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getFeatureVariables = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/features/` + id + "/variables", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getAllSpaces = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces?show_details?=false&max_count=100`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getSpaceVariables = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + id + '/variables', {
        headers: await getHeaders(),
    });
    return results.data && results.data.variables;
  };

  export const getSpaceNotes = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + id + '/notes', {
        headers: await getHeaders(),
    });
    return results.data && results.data.notes;
  };


  export const getBuildingsForSite = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + "/buildings", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getBuildingFloors = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id + "/floors", {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const getBuildingNotes = async (id) => {
    let results = await axios.get(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id + '/notes', {
        headers: await getHeaders(),
    });
    return results.data && results.data.notes;
  };

  export const addSiteNote = async (id, note) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + id + `/notes`, note, {
        headers: await getHeaders(),
    });
    return results.data;
  };
  export const addSpace = async (space) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces`, space, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addSpaceNote = async (id, note) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + id + `/notes`, note, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addZone = async (zone) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones`, zone, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addZoneSpace = async (id, zoneSpaceAdd) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/${id}/spaces`, zoneSpaceAdd, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const removeZoneSpace = async (id, space) => {
    let results = await axios.delete(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/${id}/spaces/${space.id}`, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addFloor = async (floor) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/floors`, floor, {
        headers: await getHeaders(),
    });
    return results && results.data;
  };

  export const addInterface = async (site_id, i) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/${site_id}/interfaces/`, i, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const updateInterface = async (site_id, i) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/${site_id}/interfaces/${i.interface_id}/`, i, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addBuilding = async (building) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings`, building, {
        headers: await getHeaders(),
    });
    return results.data;
  };
  export const addBuildingNote = async (id, note) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + id + `/notes`, note, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addEquipment = async (equipment) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/equipment`, equipment, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addEquipmentNote = async (id, note) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + id + `/notes`, note, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addEquipmentPoint = async (id, point) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + id + `/points`, point, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addRelatedEquipment = async (equipment_id, related_equipment) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + equipment_id + `/related`, related_equipment, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const removeRelatedEquipment = async (equipment_id, related_equipment_id) => {
    let results = await axios.delete(BUILDING_METADATA_SERVICE_BASE() + `/equipment/${equipment_id}/related/${related_equipment_id}`, null, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addProduct = async (product) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/products`, product, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addFeature = async (feature) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/${feature.space_id}/features/`, feature, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addZoneNote = async (id, note) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/` + id + `/notes`, note, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const addVariable = async (variable, context, id) => {
    if (!context || !id) throw 'Context and Id are required'
    let path = context === "equipment" ? "equipment" :
               context === "feature" ? "features" :
               context === "site" ? "locations/sites" :
               context === "building" ? "locations/buildings" :
               context === "space" ? "locations/spaces" :
               context === "outdoor-area" ? "locations/outdoor-areas" :
               context === "zone" ? "locations/zones" : null

    if (!path) throw 'Path not available for this context'

    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/` + path + `/` + id + `/variables`, variable, {
        headers: await getHeaders(),
    });
    return results.data;
  };


  export const updateSite = async (site) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/` + site.site_id + "/", site, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const updateSpace = async (space) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + space.id + "/", space , {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const updateZone = async (zone) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/locations/zones/` + zone.id + "/", zone , {
        headers: await getHeaders(),
    });
    return results.data;
  };


  export const updateBuilding = async (building) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/locations/buildings/` + building.id + "/", building , {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const updateEquipment = async (equipment) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + equipment.equipment_id + "/", equipment , {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const mergeEquipment = async (src_equipment_id, dst_equipment_id, options = {}) => {
    let results = await axios.post(BUILDING_METADATA_SERVICE_BASE() + `/equipment/${dst_equipment_id}/merge/${src_equipment_id}`, {
        ...options,
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const updateEquipmentPoint = async (equipment_id, point) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/equipment/${equipment_id }/points/${point.point_id}`, point , {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const updateFeature = async (feature) => {
    let results = await axios.put(BUILDING_METADATA_SERVICE_BASE() + `/locations/spaces/` + feature.space_id + `/features/` + feature.id + "/", feature , {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const deleteEquipmentPoint = async (point) => {
    let results = await axios.delete(BUILDING_METADATA_SERVICE_BASE() + `/equipment/` + point.equipment_id + `/points/` + point.point_id, {
        headers: await getHeaders(),
    });
    return results.data;
  };

  export const deleteInterface = async (interface_id) => {
    let results = await axios.delete(BUILDING_METADATA_SERVICE_BASE() + `/locations/sites/interfaces/` + interface_id, {
        headers: await getHeaders(),
    });
    return results.data;
  };
